import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/img/logonaam.png'
import _imports_1 from '@/assets/img/logo.png'


const _hoisted_1 = { class: "min-h-screen flex flex-col" }
const _hoisted_2 = { class: "container mx-auto px-4 py-4" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "hidden md:flex items-center gap-8" }
const _hoisted_5 = { class: "flex items-center rounded-lg border border-white/20 overflow-hidden" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "md:hidden flex items-center gap-3" }
const _hoisted_8 = { class: "flex items-center rounded-lg border border-white/20 overflow-hidden" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_11 = {
  key: 1,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = {
  key: 0,
  class: "fixed top-0 left-0 z-50 h-full w-72 bg-td-navy shadow-2xl flex flex-col"
}
const _hoisted_13 = { class: "flex items-center justify-between px-5 pt-6 pb-4 border-b border-white/10" }
const _hoisted_14 = { class: "flex-1 overflow-y-auto px-5 py-6 space-y-1" }
const _hoisted_15 = { class: "px-5 pb-6 space-y-3 border-t border-white/10 pt-4" }
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = { class: "gradient-navy text-white relative overflow-hidden" }
const _hoisted_18 = { class: "container mx-auto px-4 pt-16 pb-10 relative z-10" }
const _hoisted_19 = { class: "grid md:grid-cols-3 gap-10" }
const _hoisted_20 = { class: "text-white/60 text-sm leading-relaxed max-w-xs" }
const _hoisted_21 = { class: "text-sm font-bold uppercase tracking-wider text-white/40 mb-4" }
const _hoisted_22 = { class: "flex flex-col gap-2" }
const _hoisted_23 = { class: "md:justify-self-end md:text-right" }
const _hoisted_24 = { class: "text-sm font-bold uppercase tracking-wider text-white/40 mb-4" }
const _hoisted_25 = { class: "space-y-2 text-sm text-white/60" }
const _hoisted_26 = { class: "border-t border-white/10 relative z-10" }
const _hoisted_27 = { class: "container mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/40" }

import { computed, ref, watch, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { useI18n, type Locale } from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const { locale, t, setLocale } = useI18n();
const locales: Locale[] = ["nl", "en"];

const mobileMenuOpen = ref(false);
const navVisible = ref(true);
const scrolled = ref(false);
const lastScrollY = ref(0);

// The portfolio landing now has a light top section, so the transparent
// header (white logo/nav) would be invisible there — keep it solid.
const solidHeader = computed(() => scrolled.value || route.name === "portfolio");

watch(mobileMenuOpen, (open) => {
  document.body.style.overflow = open ? 'hidden' : '';
});

const onScroll = () => {
  const currentY = window.scrollY;
  navVisible.value = currentY < lastScrollY.value || currentY < 50;
  scrolled.value = currentY > 20;
  lastScrollY.value = currentY;
};

onMounted(() => {
  window.addEventListener("scroll", onScroll, { passive: true });
});

onUnmounted(() => {
  window.removeEventListener("scroll", onScroll);
});

const navigation = computed(() => [
  { name: t.value.nav.home, href: "/" },
  { name: t.value.nav.portfolio, href: "/portfolio" },
  { name: t.value.nav.whoAreWe, href: "/who-are-we" },
  { name: t.value.nav.contact, href: "/contact" },
]);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: _normalizeClass([
        'fixed top-0 left-0 w-full z-50 transition-all duration-300',
        solidHeader.value
          ? 'bg-td-navy/95 shadow-lg shadow-td-navy/10'
          : 'bg-transparent',
        navVisible.value ? 'translate-y-0' : '-translate-y-full',
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "flex items-center gap-3 group"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "TEKDAM",
                class: "h-10 w-auto brightness-0 invert"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("nav", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: item.href,
                to: item.href,
                class: _normalizeClass([
                'text-sm font-semibold uppercase tracking-wider transition-colors duration-200',
                _ctx.$route.path === item.href
                  ? 'text-td-blue-light'
                  : 'text-white/80 hover:text-white',
              ])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            }), 128)),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(locales, (lang) => {
                return _createElementVNode("button", {
                  key: lang,
                  class: _normalizeClass([
                  'px-2.5 py-1.5 text-xs font-bold uppercase transition-colors',
                  _unref(locale) === lang ? 'bg-td-blue text-white' : 'text-white/60 hover:text-white',
                ]),
                  onClick: ($event: any) => (_unref(setLocale)(lang))
                }, _toDisplayString(lang), 11, _hoisted_6)
              }), 64))
            ]),
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "btn-primary text-xs py-2.5 px-6"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t).nav.getInTouch), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(locales, (lang) => {
                return _createElementVNode("button", {
                  key: lang,
                  class: _normalizeClass([
                  'px-2.5 py-1.5 text-xs font-bold uppercase transition-colors',
                  _unref(locale) === lang ? 'bg-td-blue text-white' : 'text-white/60 hover:text-white',
                ]),
                  onClick: ($event: any) => (_unref(setLocale)(lang))
                }, _toDisplayString(lang), 11, _hoisted_9)
              }), 64))
            ]),
            _createElementVNode("button", {
              class: "text-white p-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileMenuOpen.value = !mobileMenuOpen.value))
            }, [
              (!mobileMenuOpen.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M4 6h16M4 12h16M4 18h16"
                    }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    }, null, -1)
                  ]))]))
            ])
          ])
        ])
      ])
    ], 2),
    _createVNode(_Transition, { name: "mobile-fade" }, {
      default: _withCtx(() => [
        (mobileMenuOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-40 bg-black/60",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileMenuOpen.value = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "mobile-slide" }, {
      default: _withCtx(() => [
        (mobileMenuOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[9] || (_cache[9] = _createElementVNode("img", {
                  src: _imports_1,
                  alt: "TEKDAM",
                  class: "h-8 w-auto brightness-0 invert"
                }, null, -1)),
                _createElementVNode("button", {
                  class: "text-white p-1",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileMenuOpen.value = false))
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("svg", {
                    class: "w-6 h-6",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("nav", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: item.href,
                    to: item.href,
                    class: _normalizeClass([
              'block px-4 py-3 rounded-xl text-sm font-semibold uppercase tracking-wider transition-colors',
              _ctx.$route.path === item.href
                ? 'bg-td-blue/20 text-td-blue-light'
                : 'text-white/70 hover:bg-white/5 hover:text-white',
            ]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (mobileMenuOpen.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_router_link, {
                  to: "/contact",
                  class: "block text-center w-full btn-primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (mobileMenuOpen.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t).nav.getInTouch), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("main", _hoisted_16, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", _hoisted_17, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "absolute top-0 right-0 w-96 h-96 rounded-full glow-orb-5 -translate-y-1/2 translate-x-1/3" }, null, -1)),
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "absolute bottom-0 left-0 w-64 h-64 rounded-full glow-orb-5 translate-y-1/2 -translate-x-1/3" }, null, -1)),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("img", {
              src: _imports_0,
              alt: "TEKDAM",
              class: "h-10 w-auto brightness-0 invert mb-4"
            }, null, -1)),
            _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t).footer.description), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h4", _hoisted_21, _toDisplayString(_unref(t).footer.navigation), 1),
            _createElementVNode("nav", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (link) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: link.href,
                  to: link.href,
                  class: "text-sm text-white/60 hover:text-td-blue-light transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(link.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h4", _hoisted_24, _toDisplayString(_unref(t).footer.contact), 1),
            _createElementVNode("div", _hoisted_25, [
              _cache[11] || (_cache[11] = _createElementVNode("p", { class: "font-semibold text-white" }, "TEKDAM BV", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("p", null, "BTW: BE1024.973.363", -1)),
              _createElementVNode("p", null, _toDisplayString(_unref(t).footer.location), 1),
              _cache[13] || (_cache[13] = _createElementVNode("p", null, [
                _createElementVNode("a", {
                  href: "mailto:info@tekdam.be",
                  class: "text-td-blue-light hover:text-white transition-colors"
                }, "info@tekdam.be")
              ], -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", null, [
            _createTextVNode(" © 2026 TEKDAM BV. " + _toDisplayString(_unref(t).footer.rights) + " ", 1),
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "mx-1.5" }, "·", -1)),
            _createVNode(_component_router_link, {
              to: "/privacy",
              class: "hover:text-td-blue-light transition-colors underline-offset-2 hover:underline"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t).footer.privacy), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("span", null, _toDisplayString(_unref(t).footer.tagline), 1)
        ])
      ])
    ])
  ]))
}
}

})